import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SelectPayload, Option } from '../../interfaces';
import { BotChatCard } from '@/shared/components';
import { BotChatCardType } from '@/shared/enums/botChatCardType.enum';

@Component({
  selector: 'bevvi-select-payload',
  imports: [BotChatCard],
  templateUrl: './select-payload.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectPayloadComponent {
  public readonly payload = input.required<SelectPayload>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();
  protected readonly type = BotChatCardType;

  public onSelectChange(options: Option[]): void {
    const selected = options.find((o) => o.selected);
    if (selected) {
      this.userReply.emit(selected.label);
    }
  }
}
